import { render, staticRenderFns } from "./LoadLimitCollectionInputContainer.vue?vue&type=template&id=550b2aa8&scoped=true"
import script from "./LoadLimitCollectionInputContainer.vue?vue&type=script&lang=js"
export * from "./LoadLimitCollectionInputContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550b2aa8",
  null
  
)

export default component.exports